import Browser from '@mindful-web/marko-web/browser';
import Shared from '@industrial-media/package-global-new/browser';

Shared(Browser);

export default Browser;
